import { createContext, useContext } from "react";

/** Timings the screens use. Tests hand in small values; nothing else is configurable. */
export interface AppConfig {
  /** how often a running download is asked for its progress */
  pollIntervalMs: number;
  /** progress polling stops after this long, whatever the job says (the worker fails stalled jobs at 20 min) */
  pollLimitMs: number;
  /** pause after the last keystroke before tag suggestions are asked for */
  suggestDelayMs: number;
  /** the sidebar's download summary is asked again this often while I have jobs queued or running */
  summaryActiveMs: number;
  /** ... and this often while I have none (46 Spec 3.5) */
  summaryIdleMs: number;
}

export const DEFAULT_CONFIG: AppConfig = {
  pollIntervalMs: 2000,
  pollLimitMs: 25 * 60 * 1000,
  suggestDelayMs: 150,
  summaryActiveMs: 15_000,
  summaryIdleMs: 60_000,
};

const Ctx = createContext<AppConfig>(DEFAULT_CONFIG);

export const ConfigProvider = Ctx.Provider;

export function useConfig(): AppConfig {
  return useContext(Ctx);
}
